import React, { createContext, useState, useEffect } from 'react';
import LoadGoogleMaps from './LoadGoogleMaps';

export const MapContext = createContext();

let googleMapsAPICache = null;
let mapLoadedCache = false;
let loadMapsPromise = null;

const runtimeConfig = window.__CONFIG__ || {};
const environment =
  runtimeConfig.REACT_APP_ENVIRONMENT ||
  process.env.REACT_APP_ENVIRONMENT ||
  'development';

const apiKey =
  environment === 'production'
    ? (runtimeConfig.REACT_APP_GOOGLE_MAPS_API_KEY_PROD ||
       process.env.REACT_APP_GOOGLE_MAPS_API_KEY_PROD ||
       '')
    : (runtimeConfig.REACT_APP_GOOGLE_MAPS_API_KEY_DEV ||
       process.env.REACT_APP_GOOGLE_MAPS_API_KEY_DEV ||
       '');

export const MapProvider = ({ children }) => {
  const [googleMapsAPI, setGoogleMapsAPI] = useState(googleMapsAPICache);
  const [mapLoaded, setMapLoaded] = useState(mapLoadedCache);

  useEffect(() => {
    const loadMaps = async () => {
      if (mapLoadedCache && googleMapsAPICache) {
        setGoogleMapsAPI(googleMapsAPICache);
        setMapLoaded(mapLoadedCache);
        return;
      }
      if (!loadMapsPromise) {
        loadMapsPromise = LoadGoogleMaps(apiKey, ['places', 'marker'])
          .then(() => {
            if (
              window.google &&
              window.google.maps &&
              window.google.maps.ControlPosition
            ) {
              googleMapsAPICache = window.google.maps;
              mapLoadedCache = true;
              setGoogleMapsAPI(googleMapsAPICache);
              setMapLoaded(mapLoadedCache);
            } else {
              console.error('Google Maps API not fully available after loading.');
            }
          })
          .catch((error) => {
            console.error('Error loading Google Maps:', error);
          });
      } else {
        await loadMapsPromise;
        setGoogleMapsAPI(googleMapsAPICache);
        setMapLoaded(mapLoadedCache);
      }
    };

    loadMaps();
  }, [apiKey]);

  return (
    <MapContext.Provider value={{ googleMapsAPI, mapLoaded }}>
      {children}
    </MapContext.Provider>
  );
};
